import React from 'react';
import { Chip, Stack } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useAnalyticsFilters } from '../hooks/useAnalyticsFilters';

import { Icon } from '@liftango/ui-icons';
import { ICON_FALLBACKS } from '../../../../utils/iconFallbacks';
export default function ActiveFilterChips() {
  const { t } = useTranslation('admin');
  const { filters, setFilters } = useAnalyticsFilters();

  const chips: Array<{ key: string; label: string; icon: React.ReactElement; clear: () => void }> = [];

  if (filters.eventName) {
    chips.push({
      key: 'eventName',
      label: t('analytics.filterChips.event', { value: filters.eventName }),
      icon: <Icon d={ICON_FALLBACKS.Label} size={20} />,
      clear: () => setFilters({ eventName: null }),
    });
  }
  if (filters.category) {
    chips.push({
      key: 'category',
      label: t('analytics.filterChips.category', { value: filters.category }),
      icon: <Icon d={ICON_FALLBACKS.Category} size={20} />,
      clear: () => setFilters({ category: null }),
    });
  }
  if (filters.customerId) {
    chips.push({
      key: 'customerId',
      label: t('analytics.filterChips.customer', { value: filters.customerId }),
      icon: <Icon d={ICON_FALLBACKS.Business} size={20} />,
      clear: () => setFilters({ customerId: null }),
    });
  }
  if (filters.actorId) {
    chips.push({
      key: 'actorId',
      label: t('analytics.filterChips.user', { value: filters.actorId }),
      icon: <Icon name="user" size={20} />,
      clear: () => setFilters({ actorId: null }),
    });
  }
  if (filters.screen) {
    chips.push({
      key: 'screen',
      label: t('analytics.filterChips.screen', { value: filters.screen }),
      icon: <Icon d={ICON_FALLBACKS.Monitor} size={20} />,
      clear: () => setFilters({ screen: null }),
    });
  }
  if (filters.actorType) {
    chips.push({
      key: 'actorType',
      label: `Actor type: ${filters.actorType}`,
      icon: <Icon d={ICON_FALLBACKS.SmartToy} size={20} />,
      clear: () => setFilters({ actorType: null }),
    });
  }
  if (!filters.hideLegacy) {
    chips.push({
      key: 'showLegacy',
      label: t('analytics.filterChips.includingLegacy'),
      icon: <Icon name="eye-slash" size={20} />,
      clear: () => setFilters({ hideLegacy: true }),
    });
  }

  if (chips.length === 0) return null;

  return (
    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
      {chips.map((c) => (
        <Chip
          key={c.key}
          icon={c.icon}
          label={c.label}
          size="small"
          onDelete={c.clear}
          variant="outlined"
        />
      ))}
    </Stack>
  );
}
